<ng-template #sideModal let-offcanvas>
  <div class="offcanvas-header border-bottom">
    <h5 class="offcanvas-title fw-normal" id="sideModalLabel">
      Calendar Settings
    </h5>
    <button type="button" class="btn-close" (click)="offcanvas.dismiss()" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <app-branch-selector (branchSelected)="onBranchSelected($event)" />
    <app-role-selector (rolesSelected)="onRolesSelected($event)" />
    @if (showForemanSelector()) {
      <app-foreman-selector
        [branchId]="effectiveBranchId"
        [disabled]="!effectiveBranchId"
        [roles]="pendingRoles"
        (foremenSelected)="onForemenSelected($event)" />
    }
    <app-installation-ability-selector
      (abilitiesSelected)="onAbilitiesSelected($event)" />
  </div>
  <div class="offcanvas-footer border-top p-3">
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-outline-secondary" (click)="resetToDefault()">
        Reset to Default
      </button>
      <button type="button" class="btn btn-primary" (click)="applySettings()">
        Apply Settings
      </button>
    </div>
  </div>
</ng-template>
